<template>
  <el-dialog
    :visible.sync="dialogVisible"
    :title="$t('选择提现方式')"
    width="440px"
    custom-class="withdraw-type-dialog"
    append-to-body
    :close-on-click-modal="false"
  >
    <p class="withdraw-type-dialog__hint">{{ $t('资金将从资金账户转出，请选择到账方式') }}</p>
    <button class="withdraw-type-option" type="button" @click="select('withdraw')">
      <span class="withdraw-type-option__icon is-chain"><i class="el-icon-link" /></span>
      <span>
        <strong>{{ $t('链上提现') }}</strong>
        <small>{{ $t('提现至 Tron (TRC20) 钱包地址') }}</small>
      </span>
      <i class="el-icon-arrow-right" />
    </button>
    <button class="withdraw-type-option" type="button" @click="select('internal-withdraw')">
      <span class="withdraw-type-option__icon is-internal"><i class="el-icon-user" /></span>
      <span>
        <strong>{{ $t('内部转账') }}</strong>
        <small>{{ $t('转至其他 UPlus 用户的资金账户，免手续费') }}</small>
      </span>
      <i class="el-icon-arrow-right" />
    </button>
  </el-dialog>
</template>

<script>
export default {
  name: 'WithdrawalTypeModal',
  props: {
    visible: { type: Boolean, default: false }
  },
  computed: {
    dialogVisible: {
      get() { return this.visible },
      set(value) { this.$emit('update:visible', value) }
    }
  },
  methods: {
    select(type) {
      this.$emit('select', type)
    }
  }
}
</script>

<style>
.withdraw-type-dialog {
  max-width: calc(100vw - 28px);
  border-radius: 14px;
}
.withdraw-type-dialog .el-dialog__header {
  padding: 20px 22px 13px;
  border-bottom: 1px solid #edf0f5;
}
.withdraw-type-dialog .el-dialog__title {
  color: #1c2333;
  font-size: 16px;
  font-weight: 800;
}
.withdraw-type-dialog .el-dialog__body { padding: 18px 22px 22px; }
.withdraw-type-dialog__hint {
  margin: 0 0 13px;
  color: #8a90a0;
  font-size: 12px;
}
.withdraw-type-option {
  display: grid;
  width: 100%;
  min-height: 72px;
  padding: 12px 14px;
  align-items: center;
  grid-template-columns: 42px minmax(0, 1fr) auto;
  gap: 12px;
  color: #252b36;
  border: 1px solid #e5e9f0;
  border-radius: 10px;
  outline: none;
  background: #fff;
  text-align: left;
  cursor: pointer;
}
.withdraw-type-option + .withdraw-type-option { margin-top: 10px; }
.withdraw-type-option:hover { border-color: #9fbdff; background: #f8faff; }
.withdraw-type-option > span:nth-child(2) { min-width: 0; }
.withdraw-type-option strong,
.withdraw-type-option small { display: block; }
.withdraw-type-option strong { font-size: 14px; font-weight: 700; }
.withdraw-type-option small { margin-top: 4px; color: #8a90a0; font-size: 11px; }
.withdraw-type-option > .el-icon-arrow-right { color: #a7aebb; }
.withdraw-type-option__icon {
  display: grid;
  width: 42px;
  height: 42px;
  place-items: center;
  border-radius: 11px;
  font-size: 18px;
}
.withdraw-type-option__icon.is-chain { color: #d97706; background: #fff3df; }
.withdraw-type-option__icon.is-internal { color: #1f6bff; background: #eaf1ff; }

@media (max-width: 760px) {
  .withdraw-type-dialog .el-dialog__body {
    padding: 0 18px calc(50px + env(safe-area-inset-bottom)) !important;
  }
  .withdraw-type-dialog__hint { margin-bottom: 12px; font-size: 12px; }
  .withdraw-type-option { min-height: 70px; padding: 11px 13px; }
}
</style>